import React from 'react'
import I18n from '@src/i18n';

const gifDescGetter = (selectedComponent: string) => {
  if (selectedComponent) {
    switch (selectedComponent) {
      case 'Yes/No':
        return (<div>
          <h3 className="title-text">{I18n.l("formflow.lite.tooltip.title.yesOrNo")}</h3>
          <p>{I18n.l("formflow.lite.tooltip.yesOrNo")}</p>
        </div>
        )
      case 'Text':
        return (<div>
          <h3 className="title-text">{I18n.l("formflow.lite.tooltip.title.text")}</h3>
          <p>{I18n.l("formflow.lite.tooltip.text")}</p>
        </div>
        )
      case 'Photo':
        return (<div>
          <h3 className="title-text">{I18n.l("formflow.lite.tooltip.title.photo")}</h3>
          <p>{I18n.l("formflow.lite.tooltip.photo")}</p>
        </div>
        )
      case 'Number':
        return (<div>
          <h3 className="title-text">{I18n.l("formflow.lite.tooltip.title.number")}</h3>
          <p>{I18n.l("formflow.lite.tooltip.number")}</p>
        </div>
        )
      case 'Date':
        return (<div>
          <h3 className="title-text">{I18n.l("formflow.lite.tooltip.title.date")}</h3>
          <p>{I18n.l("formflow.lite.tooltip.date")}</p>
        </div>
        )
      case 'GPS':
        return (<div>
          <h3 className="title-text">{I18n.l("formflow.lite.tooltip.title.gps")}</h3>
          <p>{I18n.l("formflow.lite.tooltip.gps")}</p>
        </div>
        )
      case 'Audio':

        return (<div>
          <h3 className="title-text">{I18n.l("formflow.lite.tooltip.title.audio")}</h3>
          <p>{I18n.l("formflow.lite.tooltip.audio")}</p>
        </div>
        )
      case 'Draw':
        return (<div>
          <h3 className="title-text">{I18n.l("formflow.lite.tooltip.title.draw")}</h3>
          <p>{I18n.l("formflow.lite.tooltip.draw")}</p>
        </div>
        )
      case 'Model':
        return (<div>
          <h3 className="title-text">{I18n.l("formflow.lite.tooltip.title.model")}</h3>
          <p>{I18n.l("formflow.lite.tooltip.model")}</p>
        </div>
        )
      case 'SAMPLETEXT':
        return (<div>
          <h3 className="title-text">{I18n.l("formflow.lite.tooltip.title.sampleText")}</h3>
          <p>{I18n.l("formflow.lite.tooltip.sampleText")}</p>
        </div>
        )
      case 'Score':
        return (<div>
          <h3 className="title-text">{I18n.l("formflow.lite.tooltip.title.score")}</h3>
          <p>{I18n.l("formflow.lite.tooltip.score")}</p>
        </div>
        )
      case 'SAMPLEIMAGE':
        return (<div>
          <h3 className="title-text">{I18n.l("formflow.components.imageComponent.titleImageComponent")}</h3>
          <p>{I18n.l("formflow.lite.tooltip.sampleImage")}</p>
        </div>
        )
      case 'SAMPLEVIDEO':
        return (<div>
          <h3 className="title-text">{I18n.l("formflow.components.sampleVideo.titleSampleVideoComponent")}</h3>
          <p>{I18n.l("formflow.lite.tooltip.sampleVideo")}</p>
        </div>
        )
      case 'Select':
        return (<div>
          <h3 className="title-text">{I18n.l("formflow.components.selectComponent.titleDateComponent")}</h3>
          <p>{I18n.l("formflow.lite.tooltip.select")}</p>
        </div>
        )
      case 'TODO':
        return (<div>
          <h3 className="title-text">{I18n.l("formflow.components.goToComponent.titleGoToComponent")}</h3>
          <p>{I18n.l("formflow.lite.tooltip.todo")}</p>
        </div>
        )
      case 'Calculator':
        return (<div>
          <h3 className="title-text">{I18n.l("formflow.components.calculatorComponent.title")}</h3>
          <p>{I18n.l("formflow.lite.tooltip.calculator")}</p>
        </div>
        )
      case 'Sample':
        return (<div>
          <h3 className="title-text">{I18n.l("formflow.components.sampleComponent.titleSampleComponent")}</h3>
          <p>{I18n.l("formflow.lite.tooltip.sample")}</p>
        </div>
        )
      case 'QRCode':
        return (<div>
          <h3 className="title-text">{I18n.l("formflow.components.sampleComponent.titleQRCodeComponent")}</h3>
          <p>{I18n.l("formflow.lite.tooltip.qrcode")}</p>
        </div>
        )
      case 'ImageRecognition':
        return (<div>
          <h3 className="title-text">{I18n.l("formflow.components.imageRecognition.title")}</h3>
          <p>{I18n.l("formflow.components.imageRecognition.description")}</p>
        </div>
        )
      case 'FileUpload':
        return (<div>
          <h3 className="title-text">{I18n.l("formflow.components.fileUpload.title")}</h3>
          <p>{I18n.l("formflow.components.fileUpload.description")}</p>
        </div>
        )
    }
  }
}

export default gifDescGetter
